// Jedno miejsce z nazwami i kolorami statusów — żeby „z uwagami" wyglądało tak
// samo na pulpicie, liście napraw i w panelu admina.

import type { RunSummary } from "./api";

export interface Pill {
  cls: "acc" | "ok" | "warn" | "crit" | "";
  text: string;
}

export function runPill(r: Pick<RunSummary, "status" | "mode" | "progress">): Pill {
  if (r.status === "running") return { cls: "acc", text: r.progress?.label ?? "w toku" };
  if (r.status === "failed") return { cls: "crit", text: "nie powiodło się" };
  // Skan ukończony, ale coś wymaga uwagi (część plików bez analizy AI albo
  // strona nadal nie działa). Raport istnieje — to nie porażka.
  if (r.status === "warning") return { cls: "warn", text: "z uwagami" };
  return r.mode === "quarantine" ? { cls: "ok", text: "naprawiono" } : { cls: "ok", text: "sprawdzono" };
}

export const invoicePill: Record<string, Pill> = {
  issued: { cls: "warn", text: "do zapłaty" },
  paid: { cls: "ok", text: "zapłacona" },
  cancelled: { cls: "", text: "anulowana" },
};

export const supportPill: Record<string, Pill> = {
  open: { cls: "crit", text: "nowe" },
  in_progress: { cls: "acc", text: "w realizacji" },
  closed: { cls: "ok", text: "zamknięte" },
};

export const modeText = (mode: "report" | "quarantine") =>
  mode === "quarantine" ? "sprawdzenie i naprawa" : "tylko sprawdzenie";
